<template>
 <!-- 登录 -->
  <div class="my">
    <Login ref="login"  />
    <div class="my_top">
      <div class="my_title">
        <div class="go_back" @click="goBack"></div>
        <div class="my_title_text">个人中心</div>
      </div>
      <div v-if="state.userInfo && state.userInfo.islogin" class="my_user_info">
        <div class="my_user_info_avatar">
          
          <img :src="(state.userInfo && state.userInfo.avatar && state.userInfo.avatar!=='false' && state.userInfo.avatar!=='true' )?state.userInfo.avatar:'https://static.dd-img.com/h5/img/app/rangRank.png'" alt="">
        </div>
        <div class="my_user_info_name">{{state.userInfo &&  state.userInfo.nickname}}</div>
      </div>
        <div v-else class="my_user_info" @click="loginForPocket">
        <div class="my_user_info_avatar">
          <img src="https://i2.dd-img.com/other/6b2d4307fa46a7122213bdd06e429e67.png" alt="">
        </div>
        <div class="my_user_info_name">点击登录</div>
      </div>
    </div>
    <Withdrawal/>
    <template v-if="order_list.length>0">
      <div v-for="(goods_item) in order_list" class="my_card my_seckill_info" :key="goods_item.coupon_id">
        <template v-for="(item) in goods_item.goods" :key="item.goods_id">
          <div class="my_seckill_info_box">
            <div class="my_seckill_info_left">
              <div class="my_seckill_info_car_img">
                <div class="my_seckill_info_car_img_box">
                  <img :src="item.img_url" alt="">
                </div>
              </div>
              <div class="my_seckill_info_time">
                <div class="my_seckill_info_time_attr">距结束：</div>
                <div class="my_seckill_info_time_val">
                  <van-count-down :time="time">
                  <template #default="timeData">
                    <span class="block countdown_day">{{ timeData.days }}</span>
                    <span class="colon">天</span>
                    <span class="block countdown_hour">{{
                      timeData.hours > 9 ? timeData.hours : "0" + timeData.hours
                    }}</span>
                    <span class="colon">:</span>
                    <span class="block countdown_minute">{{
                      timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes
                    }}</span>
                    <span class="colon">:</span>
                    <span class="block countdown_second">{{
                      timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds
                    }}</span>
                  </template>
                </van-count-down>
                </div>
              </div>
            </div>
            <div class="my_seckill_info_right">
              <div class="my_seckill_info_car_name">{{item.goods_name}}</div>
              <div class="my_seckill_info_car_guide">厂商指导价：{{item.goods_amount}}万</div>
              <div class="my_seckill_info_car_subsidy">限时优惠：{{item.discount_amount}}万</div>
              <div v-if="goods_item.has_take==0" class="my_seckill_info_getcar_btn" @click="getPickupCarMsg(goods_item.coupon_id,goods_item.user_coupon_id)">完善提车信息</div>
              <div v-else class="my_seckill_info_getcar_btn" @click="lookPickupCarMsg(goods_item)">查看提车信息</div>
            </div>
          </div>
        </template>
        <div class="my_seckill_order_sn">订单号：{{goods_item.order_sn}}</div>
        <div class="my_seckill_info_text">请于2021年7月31日23:59:59前上传提车信息，否则补贴将失效并不再返还99元秒杀款。</div>
      </div>
    </template>
    
 
    <div class="ddb_info">本活动最终解释权归<br>电动邦科技（北京）有限公司</div>

    <div class="mask" v-if="carry_car>0">
        <div class="mask_box">
            <div class="mask_close" @click="hideMaskBox"></div>
            <div v-if="carry_car==1" class="mask_content mask_content_1">
              <div class="mask_carry_car_tit">完善提车信息</div>
              <div class="mask_carry_car_text">恭喜您，抢到秒杀啦！</div>
              <div class="mask_carry_car_text2">提车时请务必携带身份证以及驾驶证，否则无法完成购买</div>
              <div class="mask_carry_car_input">
                <input type="text" placeholder="请输入您的身份证号码" maxlength="18" v-model.trim="coupon_info.sfzhm">
              </div>
              <div class="mask_carry_car_dealer_tit">选择经销商</div>
              <div class="mask_carry_car_dealers">
                <div v-for="(item,ind) in dealer_list" class="mask_carry_car_dealer_item" :key="ind" @click="choose_dealer(ind,item)">
                  <div class="mask_carry_car_dealer_item_left">
                    <div :class="{'mask_carry_car_dealer_item_check':true,'active':(ind == dealer_ind)}"></div>
                  </div>
                  <div class="mask_carry_car_dealer_item_info">
                    <div class="mask_carry_car_dealer_item_name">{{item.name}}</div>
                    <div class="mask_carry_car_dealer_item_address">{{item.address}}</div>
                  </div>
                </div>
              </div>
              <div class="mask_carry_car_btn" @click="takeCouponSubmit">提交</div>
            </div>
            <div v-if="carry_car==2" class="mask_content mask_content_2">
              <div class="mask_carry_car_info_item">
                <div class="mask_carry_car_info_item_attr">爱车详情：</div>
                <div class="mask_carry_car_info_item_val">{{take_info.name}}</div>
              </div>
              <div class="mask_carry_car_info_item">
                <div class="mask_carry_car_info_item_attr">订单号：</div>
                <div class="mask_carry_car_info_item_val">{{take_info.order_sn}}</div>
              </div>
              <div class="mask_carry_car_info_item">
                <div class="mask_carry_car_info_item_attr">经销商：</div>
                <div class="mask_carry_car_info_item_val">{{take_info.dealer_name}}</div>
              </div>
              <div class="mask_carry_car_info_item">
                <div class="mask_carry_car_info_item_attr">提车地点：</div>
                <div class="mask_carry_car_info_item_val">{{take_info.dealer_addr}}</div>
              </div>
              <div class="mask_carry_car_info_item">
                <div class="mask_carry_car_info_item_attr">联系电话：</div>
                <div class="mask_carry_car_info_item_val">{{take_info.dealer_tel}}</div>
              </div>
              <div class="mask_carry_car_btn mask_carry_car_btn2" @click="hideMaskBox">确定</div>
            </div>
        </div>
    </div>
    
  </div>
</template>
<script>
import Withdrawal from "@/components/brandWeek/Withdrawal.vue";
import BrandWeekStore from "@/store/modules/brandWeek";
import  Login from '@/components/brandWeek/Login.vue';
import {OrderList,dealerList,takeCoupon} from '@/service/activity/brandWeek';
//引入倒计时
import { CountDown } from "vant";
  export default {
    name: "My",
    components: {
      Withdrawal,
      Login,
     "van-count-down": CountDown,
    },
    data() {
      return {
        state: BrandWeekStore.state,
        carry_car:0,
        order_list:[],
        dealer_list:[],
        dealer_ind:-1,
        coupon_info:{
          sfzhm:'',
          dealer:null,
         
        },
       
        user_coupon_id:"",
        end_time:"2021/07/31 23:59:59"
      }
    },
    methods:{
        loginForPocket(){
            const that = this;
            that.$session.loginScope(that.$refs.login, function(is_login){
              if (is_login){
                that.getOrderList();
              }
            })
        },
        goBack(){
          window.location.href = "https://zhuanti.diandong.com/zt/2021/6/autoshow/index.html#/";
          // if (window.history.length <= 1) {
            // this.$router.replace({path:'index'})
          //   return false;
          // } else {
          //   this.$router.go(-1)
          // }
        },
        getPickupCarMsg(coupon_id,user_coupon_id){
          const that = this;
          that.$toast.clear();
          const now_time = Math.round(new Date()*1);
          const end_time = new Date(this.end_time);
          const diff_time = end_time - now_time;
          if(diff_time<0){
            that.$toast("活动已结束！")
            return false;
          }
          //添加百度统计代码
          // eslint-disable-next-line
          _hmt.push(['_trackEvent', '个人中心页', '点击获取提车信息按钮', '完善提车信息']);
          this.carry_car=1;
          that.user_coupon_id = user_coupon_id;
          dealerList(coupon_id).then(res=>{
            if(res && res.code && res.code ==200){
              that.dealer_list = res.data;
            }
          })
        },
        lookPickupCarMsg(info){ //查看提车信息
          // eslint-disable-next-line
          _hmt.push(['_trackEvent', '个人中心页', '点击获取提车信息按钮', '查看提车信息']);
          const that = this;
          that.$toast.clear();
          that.carry_car=2;
          that.take_info={
            name:info.goods[0].goods_name,
            order_sn:info.order_sn,
            dealer_name:info.dealer_name,
            dealer_addr:info.dealer_addr,
            dealer_tel:info.dealer_tel,
          }

        },
        hideMaskBox(){
          this.carry_car=0;
        },
        choose_dealer(ind,dealer_info){
          this.dealer_ind = ind;
          this.coupon_info.dealer=dealer_info;
        },
        takeCouponSubmit(){
          const that = this;
          let data = {
            type:0,
            user_coupon_id:that.user_coupon_id,
            identity_card_num:that.coupon_info.sfzhm,
            dealer_name:that.coupon_info.dealer.name || "",
            dealer_addr:that.coupon_info.dealer.address || "",
            dealer_tel:that.coupon_info.dealer.tel || "",
          }
          if(data.identity_card_num.length<18){
            that.$toast("身份证格式错误！");
            return false;
          } 
          if(!data.dealer_name){
            that.$toast("请选择经销商！");
            return false;
          }
          that.$toast.loading({
            message: '提交中...',
            forbidClick: true,
          });
          takeCoupon(data).then(res=>{
            if(res && res.code && res.code == 200){
              that.$toast("提交信息成功！");
              that.carry_car=0;
            }else{
              that.$toast.fail('提交失败,请稍后重试！');
            }
            that.coupon_info.sfzhm = "";
            that.coupon_info.dealer = {};
            that.dealer_ind = -1;
            that.getOrderList();
          }).catch(()=>{
            that.$toast("提交失败,请重试！");
            that.coupon_info.sfzhm = "";
            that.coupon_info.dealer = {};
            that.dealer_ind = -1;
          })
        },
        getOrderList(){
          const that = this;
          OrderList().then(res=>{
            if(res && res.code && res.code == 200){
              that.order_list = res.data.list;
            }else{
              console.log("orderList失败")
            }
          })
        },
    
    },
    created(){
      this.$session._restore();
      BrandWeekStore.userMethods.getUserActivityInfo();
      this.getOrderList();
      var now_time = Math.round(new Date()*1);
      var end_time = new Date(this.end_time);
      this.time = end_time - now_time;
    },
  }
</script>
<style scoped>
  .my{
    width: 100%;
    min-height: 100vh;
    background:#efefef url(../../../assets/images/brandWeek/my_top.png) no-repeat top center;
    background-size: 750px;
    padding-bottom: 230px;
    position: relative;
  }
  .my_top{
    width: 100%;
    height: 285px;
  }
  .my_title{
    width: 100%;
    height: 100px;
    position: relative;
  }
  .go_back{
    width: 100px;
    height: 100px;
    background:url(../../../assets/images/brandWeek/go_back.png) no-repeat center center;
    background-size: 40px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .my_title_text{
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 34px;
    color: #fff;
  }
  .my_user_info{
    display: flex;
    padding: 58px 50px 0;
  }
  .my_user_info_avatar{
    width: 110px;
    height: 110px;
    border: solid 4px #fff;
    border-radius: 50%;
    overflow: hidden;
  }
  .my_user_info_avatar img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .my_user_info_name{
    height: 110px;
    line-height: 110px;
    padding-left: 30px;
    font-size: 32px;
    color: #fff;
  }
  .my_card{
    width: 684px;
    padding: 20px;
    border-radius: 20px;
    background: #fff;
    margin: 0 auto 25px;
  }
  .my_seckill_info{
    position: relative;
    margin-top: 67px;
    border-top-left-radius: 0;
  }
  .my_seckill_order_sn{
    height: 42px;
    padding: 0 20px;
    position: absolute;
    top: -42px;
    left: 0;
    font-size: 20px;
    color: #fff;
    line-height: 43px;
    border-radius: 24px 24px 0 0;
    background: linear-gradient(to bottom,#4fa7e5,#7185ff);
    letter-spacing: 0px;
  }
  .my_seckill_info_box{
    width: 100%;
    display: flex;
  }
  .my_seckill_info_left{
    width: 292px;
    flex-shrink: 0;
  }
  .my_seckill_info_car_img{
    width: 261px;
    height: 185px;
    padding: 2px;
    border-radius: 17px;
    background: linear-gradient(to bottom,#a32ef5,#fc934f);
    /* display: flex;
    justify-content: center;
    align-items: center; */
  }
  .my_seckill_info_car_img_box{
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
  }
  .my_seckill_info_car_img_box::after{
    content: "秒杀成功";
    width: 123px;
    height: 27px;
    line-height: 29px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    position: absolute;
    right: -1px;
    bottom: 0;
    border-radius: 7px 0 0 0;
    background: linear-gradient(to bottom,#f24646,#fc9350);
  }
  .my_seckill_info_car_img_box img{
    width: 90%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .my_seckill_info_time{
    height: 90px;
    padding-top: 57px;
    display: flex;
  }
  .my_seckill_info_time_attr{
    line-height: 36px;
    font-size: 24px;
    color: #333333;
  }
  .my_seckill_info_time_val{
    line-height: 36px;
    font-size: 24px;
    color: #f6644a;
  }
  .my_seckill_info_time_val .van-count-down{
    line-height: 36px;
    font-size: 24px;
    color: #f6644a;
  }
  .my_seckill_info_car_name{
    min-height: 90px;
    padding-top: 10px;
    line-height: 36px;
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    padding-left: 10px;
    text-align: left;
  }
  .my_seckill_info_car_guide{
    line-height: 40px;
    white-space: nowrap;
    font-size: 24px;
    color: #333333;
    text-align: left;
  }
  .my_seckill_info_car_subsidy{
    line-height: 36px;
    white-space: nowrap;
    font-size: 24px;
    color: #f45949;
    text-align: left;
  }
  .my_seckill_info_getcar_btn{
    width: 327px;
    height: 60px;
    line-height: 60px;
    margin-top: 48px;
    border-radius: 30px;
    text-align: center;
    font-size: 28px;
    color: #fff;
    background: #8f4ed5;
  }
  .my_seckill_info_text{
    line-height: 32px;
    font-size: 22px;
    color: #6e6e6e;
    margin-top: 26px;
    padding: 10px 12px;
    text-align: left;
  }




  
  /* .my_submit_tip_info{
    display: flex;
    align-items: center;
  }
  .my_submit_tip_info_icon{
    width: 60px;
    height: 60px;
    background: url(../../../assets/images/brandWeek/icon_info.png) no-repeat center center;
    background-size: 35px 35px;
    flex-shrink: 0;
  }
  .my_submit_tip_info_text{
    padding: 5px;
    font-size: 24px;
    color: #333333;
    text-align: left;
  }

  .my_submit_form_item{
    display: flex;
    align-items: flex-end;
    height: 84px;
    padding-right: 50px;
  }
  .my_submit_form_item_attr{
    height: 32px;
    line-height: 32px;
    font-size: 28px;
    color: #7a7a96;
    min-width: 200px;
    padding-left: 36px;
    padding-right: 55px;
    white-space: nowrap;
    flex-shrink: 0;
    text-align: left;
  }
  .my_submit_form_item_val{
    flex-grow: 1;
    display: flex;
    align-items: flex-end;
  }
  .my_submit_form_item_val input{
    width: 100%;
    height: 32px;
    border: none;
    border-bottom: solid 1PX #c0c0c0;
    font-size: 26px;
    padding: 0 40px;
  }

  .my_submit_form_img{
    width: 100%;
    height: 300px;
    overflow: hidden;
    position: relative;
    margin-top: 40px;
    border: solid 1PX #ccc;
    border-radius: 5px;
  }
  .my_submit_form_img img{
    display: block;
    width: 100%;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .uploadImg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
  }
  .my_submit_form_btns{
    display: flex;
    padding: 70px 25px 46px;
    justify-content: space-between;
  }
  .my_submit_form_btn.btn_gcfp{
    width: 232px;
    height: 80px;
    line-height: 80px;
    border-radius: 40px;
    text-align: center;
    font-size: 28px;
    background: #eaeaea;
    color: #5f5f5f;
  }
  .my_submit_form_btn.btn_submit{
    width: 315px;
    height: 80px;
    line-height: 80px;
    border-radius: 40px;
    text-align: center;
    font-size: 32px;
    background: #8f4ed5;
    color: #fff;
  } */
  .ddb_info{
    width: 100%;
    padding: 28px 0 120px;
    line-height: 32px;
    font-size: 28px;
    color: #787878;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  /* 弹窗 */
.mask{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 999;
}
.mask_box{
    width: 708px;
    padding: 4px;
    border-radius: 20px;
    background:linear-gradient(to bottom,#ffde8f,#d674ff);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.mask_content{
    background: #fff;
    border-radius: 18px;
    position: relative;
}
.mask_content.mask_content_1{
  padding:70px 50px 60px 40px;
}
.mask_carry_car_tit{
  width: 356px;
  height: 82px;
  line-height: 83px;
  font-size: 36px;
  color: #fff;
  background: url(../../../assets/images/brandWeek/carry_car_tit.png) no-repeat;
  background-size:100%;
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translate(-50%);
}
.mask_carry_car_text{
  line-height: 60px;
  font-size: 40px;
  color: #ff4b4c;
}
.mask_carry_car_text2{
  line-height: 50px;
  font-size: 24px;
  color: #ff4b4c;
}
.mask_carry_car_input{
  width: 584px;
  height: 93px;
  border-radius: 46px;
  background:#f3f3f3;
  margin: 35px auto 0;
  overflow: hidden;
}
.mask_carry_car_input input{
  width: 100%;
  height: 100%;
  border: none;
  font-size: 28px;
  padding-left: 150px;
  background: url(../../../assets/images/brandWeek/icon-sfz.png) no-repeat center left;
  background-size:47px 34px;
  background-position-x: 65px;
}
.mask_carry_car_dealer_tit{
  line-height: 50px;
  margin-top: 35px;
  font-size: 30px;
  color: #333333;
  text-align: left;
}
.mask_carry_car_dealers{
  margin-top: 43px;
  padding: 0 15px;
  max-height: 315px;
  overflow-y: scroll;
}
.mask_carry_car_dealer_item{
  display: flex;
  justify-content: space-between;
  padding-bottom: 40px;
}
.mask_carry_car_dealer_item_left{
  width: 24px;
  flex-shrink: 0;
  padding-top: 10px;
}
.mask_carry_car_dealer_item_check{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  border: solid 1PX #000;
}
.mask_carry_car_dealer_item_check.active{
  background: #a255f9;
  border: solid 1PX #a255f9;
}
.mask_carry_car_dealer_item_info{
  width: 525px;
  text-align: left;
}
.mask_carry_car_dealer_item_name{
  height: 52px;
  font-size: 28px;
  color: #333333;
}
.mask_carry_car_dealer_item_address{
  line-height: 34px;
  font-size: 24px;
  color: #666666;
}

.mask_carry_car_btn{
  width: 595px;
  height: 82px;
  line-height: 83px;
  border-radius: 41px;
  background: linear-gradient(to bottom,#a56fed,#7d51dd);
  margin: 40px auto 0;
  color: #fff;
  font-size: 32px;
}
.mask_content.mask_content_2{
  padding: 110px 50px 80px;
}
.mask_carry_car_info_item{
  display: flex;
  padding: 0 17px;
  line-height: 40px;
  font-size: 30px;
  color: #333333;
  text-align: left;
  margin-bottom: 30px;
}
.mask_carry_car_info_item:last-child {
  margin-bottom: 0;
}
.mask_carry_car_info_item_attr{
  width: 175px;
  flex-shrink: 0;
}
.mask_carry_car_btn2{
  margin-top: 96px;
}
</style>